import { Schema } from "effect";
export const OPEN_FLOW_RECORDING_EVENT = "workerstation:open-flow-recording";
export const OpenFlowRecordingDetail = Schema.Struct({ sessionId: Schema.optionalKey(Schema.String), recordingId: Schema.optionalKey(Schema.String), workspaceId: Schema.optionalKey(Schema.String) });
export type OpenFlowRecordingDetail = typeof OpenFlowRecordingDetail.Type;
